import React from 'react'

export default function Heading (props) {
  return (
    <>
      <h1 className='cover-heading'>
        {props.title}
      </h1>
    </>
  )
}
